import React, { FC } from 'react'

import clsx from 'clsx'
import Link from 'next/link'

import { Toggle } from '@style-port/roov-ui-components-react'
import { Tooltip, Txt } from 'src/components/atoms'

import { useGetProject, useGlobalLoading, useProject, useToast } from 'src/hooks'
import { Routes } from 'src/routes'

type Props = {
  projectId: string
  enabled: boolean
  tooltipLinkElementId: string
  className?: string
}

export const ProjectDetailShowCommonPageToggle: FC<Props> = ({
  projectId,
  enabled,
  tooltipLinkElementId,
  className,
}) => {
  const { updateProjectShowCommonPage } = useProject()
  const { refetch } = useGetProject({ projectId })
  const { displayStandardTextToast, displayErrorTextToast } = useToast()
  const { showGlobalLoading, hideGlobalLoading } = useGlobalLoading()

  const onChange = async (newValue: boolean) => {
    showGlobalLoading()

    try {
      await updateProjectShowCommonPage({
        projectId,
        showCommonPage: newValue,
      })
      refetch()
      displayStandardTextToast(
        newValue
          ? '全ての共通コンテンツ配信をONにしました'
          : '全ての共通コンテンツ配信をOFFにしました'
      )
    } catch {
      displayErrorTextToast('全ての共通コンテンツ配信の変更に失敗しました')
    } finally {
      hideGlobalLoading()
    }
  }

  return (
    <div className={className}>
      <div className="tw-centering tw-gap-s1">
        <Tooltip
          showIcon={false}
          placement="bottom-start"
          iconPlacement="left"
          content={
            <div className="tw-p-s-2">
              <Txt>
                ONにすると、全ての
                <Link
                  href={Routes.ProjectCommonContents.path}
                  className="tw-underline hover:tw-no-underline"
                  id={tooltipLinkElementId}
                >
                  共通コンテンツ
                </Link>
                がプロジェクトへ配信され、
                <br />
                プレゼンツールと、お客様のシェアに表示されるようになります。
              </Txt>
              <Txt className="tw-text-standardText-secondary">
                ※ROOV compass管理画面では閲覧のみ。
              </Txt>
            </div>
          }
        >
          <Txt className={clsx('tw-break-keep', enabled && 'tw-text-roovPrimary-default')}>
            全共通コンテンツ配信
          </Txt>
        </Tooltip>
        <Toggle enabled={enabled} onChange={onChange} />
      </div>
    </div>
  )
}
